import axios from "axios";
import { APIOverrides } from "../../ApiOverrides";
import type { AthleteProps, BestAvailableOrderProps, GolfCourseProps, GolfHoleStatistics, GolfLeaderProps, GolfScorecardProps, GolfTournamentStatisticsProps, LeagueProps, MarketProps, OrderProps, OrderStatsProps, TournamentProps, TradeProps } from "../../types";
import { MarketComponentHelpers } from "../../MarketComponents/api";
import moment from "moment-mini";

let EVENT_SVC_API = ''
let MK_SVC_API = ''
export const GolfApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        EVENT_SVC_API = endpoints['EVENT_SVC_API'] as string;
        MK_SVC_API = endpoints['MK_SVC_API'] as string;
    },
    getTournamentById: async(tournament_id:string):Promise<TournamentProps | undefined> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/tournaments/tournament/${tournament_id}`);
            return resp.data.tournament
        } catch (e) {
            return undefined
        }
    },
    getScorecard: async(tournament_id:string, athlete_id?:string, round_number?:number):Promise<GolfScorecardProps[]> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/tournaments/golf/scorecard/${tournament_id}?athlete_id=${athlete_id}&round_number=${round_number}`);
            return resp.data.golf_scorecards
        } catch (e) {
            console.log(e)
            return []
        }
    },
    getMyAction:async(event_id:string, event_type:string):Promise<OrderProps[]> => {
        try {
            const resp = await axios.get(`${MK_SVC_API}/v1/orders/action/me?event_id=${event_id}&event_type=${event_type}`);
            return resp.data.orders
        } catch (e) {
            console.log(e);
            return []
        }
    },
    getGolfStats: async(tournament_id:string):Promise<{ golf_tournament_statistics: GolfTournamentStatisticsProps, prior_year:boolean } | undefined> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/tournaments/golf/statistics/${tournament_id}`);
            return resp.data
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    getScoreboard: async(tournament_id:string):Promise<undefined | { golf_course:GolfCourseProps, golf_leaders:GolfLeaderProps[], athletes:AthleteProps[], active_round?:number }> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/tournaments/golf/details/${tournament_id}`);
            //console.log(resp.data);
            return resp.data
        } catch (e) {
            console.log(e);
            return undefined
        }
    },
    getLeagueById:async(league_id:string):Promise<LeagueProps | undefined> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/leagues/league/${league_id}`);
            return resp.data.league
        } catch (e) {
            return undefined
        }
    },
}

export const GolfHelpers = {
    getGolfersOnHole: (golf_leaders:GolfLeaderProps[], hole_number:number, active_round?:number):GolfLeaderProps[] => {
        if(!active_round){ return [] }
        let golfers:GolfLeaderProps[] = []
        golf_leaders.map(l => {
            if(l.cut){ return }
            let round = l.leader_rounds.find(r => r.round_number == active_round);
            if(!round){ return }
            let curr_hole = round.thru + 1
            if(l.starting_hole == 10){
                //Now I just need to figure out where they actually are
                curr_hole = round.thru + 10
                if(curr_hole > 18){
                    curr_hole = curr_hole - 18
                }
            }
            if(curr_hole == hole_number){ golfers.push(l) }
        })
        return golfers
    },
    addTradeBuffer: (trade:TradeProps, market:MarketProps, buffer:number):TradeProps =>{
        if(market.max_order){
            trade.draft_liquidity = market.max_order
        }
        let new_probability = trade.probability + buffer
        if(new_probability < 1 && new_probability > 0){ trade.probability = new_probability }
        trade.odds = MarketComponentHelpers.calcAmericanOddsFromProbability(trade.probability);
        return trade
    },
    calcAllOrderStats: (orders:OrderProps[]):OrderStatsProps => {
        let open_order_count = 0, open_amt = 0, potential_winnings = 0, called_amt = 0, commission = 0;
        let resolved_stake = 0, original_stake = 0, delayed_cash = 0, winnings = 0, net_winnings = 0, unresolved_stake = 0, resolved_potential_winnings = 0, unresolved_potential_winnings = 0, unresolved_potential_net_winnings = 0, num_trades = 0, cash_rcvd = 0; 
        let unique_order_titles = [ ...new Set(orders.map(o => o.title)) ]
        let result_ind:string|undefined = undefined
        let order_ids:string[] = []
        let open_orders:string[] = []
        let wins = 0, losses = 0, draws = 0;
        orders.map(o => {
            let commission_pct = 0
            if(o.commission_pct){ commission_pct = o.commission_pct }
            order_ids.push(o.order_id)
            if(o.status === 'approved'){
                open_orders.push(o.order_id)
                open_amt += o.open_amt
                open_order_count += 1
                potential_winnings += o.potential_winnings
                called_amt += o.called_amt
            }
            if(!o.positions){ return }
            o.positions.map(p => {
                if(!p){ return }
                num_trades += 1
                cash_rcvd += p.cash_rcvd
                if(!p.result_ind){
                    delayed_cash += p.delayed_cash
                    unresolved_stake += p.stake
                    unresolved_potential_winnings += p.potential_winnings
                    unresolved_potential_net_winnings += (p.potential_winnings - ((p.potential_winnings - p.stake) * commission_pct))
    
                } else {
                    resolved_stake += p.stake
                    original_stake += p.original_stake
                    winnings += p.winnings
                    net_winnings += p.net_winnings
                    result_ind = p.result_ind
                    commission += p.commission
                    resolved_potential_winnings += p.potential_winnings
                }
            })
            if(result_ind == 'win'){ wins += 1 }
            if(result_ind == 'lose'){ losses += 1 }
            if(result_ind == 'draw'){ draws += 1 }
        })
       
        let unresolved_position_probability = unresolved_stake / unresolved_potential_winnings
        let resolved_position_probability = resolved_stake / resolved_potential_winnings
        let unresolved_position_odds = MarketComponentHelpers.calcAmericanOddsFromProbability(unresolved_position_probability)
        let resolved_position_odds = MarketComponentHelpers.calcAmericanOddsFromProbability(resolved_position_probability)
    
        let offer_probability = open_amt / potential_winnings
        let offer_odds = MarketComponentHelpers.calcAmericanOddsFromProbability(offer_probability)
        let earnings = winnings + cash_rcvd - original_stake
        let net_earnings = net_winnings + cash_rcvd - original_stake
        let roi = earnings / resolved_stake
        return {
            stat_id: 'ALL',
            unresolved_stake,
            earnings,
            resolved_stake,
            original_stake,
            roi,
            wins,
            net_earnings,
            losses,
            commission,
            net_winnings,
            unresolved_potential_net_winnings,
            unique_order_titles,
            draws,
            unresolved_position_odds,
            resolved_position_odds,
            result_ind,
            delayed_cash,
            unresolved_potential_winnings,
            resolved_potential_winnings,
            resolved_position_probability,
            unresolved_position_probability,
            num_trades,
            cash_rcvd,
            winnings,
            player_id: orders[0]?.player_id??'0',
            event_id: 'ALL',
            event_type: 'ALL',
            open_amt, potential_winnings, called_amt, offer_odds, offer_probability,
            orders: order_ids,
            open_orders
        }
    },
    generateBestAvailableOrder: (trade:TradeProps):BestAvailableOrderProps => {
        return {
            order_id: '',
            event_id:trade.event_id,
            event_type:trade.event_type,
            var_1: trade.var_1,
            odds: trade.odds,
            probability: trade.probability,
            side: trade.side,
            side_id: trade.side_id,
            side_type: trade.side_type as OrderProps['side_type'],
            market_id: trade.market_id,
            player_id: '',
            rejections:0,
            buy_sell_ind: 'buy',
            title: '',
            open_amt: 5,
            potential_winnings: MarketComponentHelpers.calcPotentialWinnings(5, trade.odds),
            expire_datetime: moment().add(10, 'minutes').format(),
            called_amt: 0
        }
    },
    getCurrentHole: (golf_leader:GolfLeaderProps, active_round?:number) => {
        if(!active_round){ return 19 }
        let round = golf_leader.leader_rounds.find(r => r.round_number == active_round)
        if(!round){ return 19 }
        let curr_hole = round.thru + 1
        if(golf_leader.starting_hole == 10){
            //Now I just need to figure out where they actually are
            curr_hole = round.thru + 10
            if(curr_hole > 18){
                curr_hole = curr_hole - 18
            }
        }
        if(golf_leader.starting_hole == 1 && curr_hole == 1 && golf_leader.tee_time){
            //lets see if they have a tee time or if they have teed off yet!
            if(moment(golf_leader.tee_time).isAfter(moment())){ curr_hole = 0 }
        }
        if(golf_leader.starting_hole == 10 && curr_hole == 10 && golf_leader.tee_time){
            //lets see if they have a tee time or if they have teed off yet!
            if(moment(golf_leader.tee_time).isAfter(moment())){ curr_hole = 0 }
        }
        return curr_hole
    },
    getParTradeFromHoleStats: (tournament_id:string, athlete:AthleteProps, market?:MarketProps, hole_stats?:GolfHoleStatistics):TradeProps[] | undefined => {
        if(!market){ return undefined }
        let trades:TradeProps[] = []
        let over_probability = 0.5
        let under_probability = 0.5
        if(!hole_stats){ return undefined }
        if(hole_stats){
            if(hole_stats.players == 0){ return undefined }
            let diff_pct = (hole_stats.avg_diff*4.5) / hole_stats.par
            over_probability = 0.5 + diff_pct
            under_probability = 1 - over_probability

            if(over_probability < 0.25){ over_probability = 0.25 }
            if(over_probability > 0.985){ over_probability = 0.985 }
            if(under_probability < 0.25){ under_probability = 0.25 }
            if(under_probability > 0.985){ under_probability = 0.985 }

        }
        market.side_options.map(so => {
            let prob = so.side == 'under' ? under_probability : over_probability

            let odds = MarketComponentHelpers.calcAmericanOddsFromProbability(prob);
            let trade:TradeProps = {
                trade_id:'',
                var_1:0,
                trade_amt:0,
                cumulative_amt:0,
                market_type:'FOR_MONEY',
                odds: odds,
                probability: prob,
                side: so.side,
                side_type: so.id_source,
                side_id: athlete.athlete_id,
                reversed_side_id: athlete.athlete_id,
                create_datetime: '', last_update_datetime: '',
                market_id: market.market_id,
                event_id:tournament_id,
                event_type: 'tournament',
                latest: true,
                position_ids: []
            };
            trades.push(trade);
        })
        return trades

    },
    getHoleStats: (hole_number:number, golf_statistics?:GolfTournamentStatisticsProps, active_round?:number) => {
        if(!golf_statistics){ return undefined }
        let round_stats = golf_statistics.round_statistics.find(r => r.round_number == active_round);
        if(!round_stats){
            round_stats = golf_statistics.round_statistics[0]
        }
        if(!round_stats) { return undefined }
        let hole_stat = round_stats.hole_statistics.find(h => h.hole_number == hole_number);
        if(!hole_stat) { return undefined }
        if(hole_stat.strokes_avg == 0){
            //We dont have any data here!! Lets try and get a previous round if we can
            let new_stat = golf_statistics.round_statistics[0]
            if(new_stat){
                let new_hole_stat = new_stat.hole_statistics.find(h => h.hole_number == hole_number);
                if(new_hole_stat && new_hole_stat.strokes_avg > 0){ hole_stat = { ...new_hole_stat, previous_round: new_stat.round_number }}
            }
        }
        return hole_stat
    },
    formatPlace :(place:number) => {
        switch(place){
            case 1:
                return '1st'
            case 2:
                return '2nd'
            case 3:
                return '3rd'
            case 4:
                return '4th'
            case 5:
                return '5th'
            case 6:
                return '6th'
            case 7:
                return '7th'
            case 8:
                return '8th'
            case 9:
                return '9th'
            default:
                return `${place}`
    
        }
    }
}